module.exports = __webpack_public_path__ + "static/media/external-machine.2d74e1c9.png";